import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withArrow = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg';
  const variants = {
    primary: 'bg-gold-500 hover:bg-gold-400 text-navy-900 focus:ring-gold-500 shadow-gold-500/20',
    secondary: 'bg-navy-800 hover:bg-navy-700 text-cream-100 focus:ring-navy-500 shadow-navy-900/20',
    outline: 'bg-transparent border-2 border-gold-500 text-gold-500 hover:bg-gold-500/10 focus:ring-gold-500'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-332">
      <span data-id="element-333">{children}</span>
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-334" />}
    </button>;
}